import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';

import Announcement from './announcement';
import Characters from './characters';
import Devices from './devices';
import Faq from './faq';
import Footer from './footer';
import Information from './information';
import Instructions from './instructions';
import jaLocale from './ja.locale';
import KeyVisual from './key-visual';
import Mission from './mission';
import News from './news';
import SocialButtons from './social-buttons';
import Trailer from './trailer';
import Trial from './trial';
import Warning from './warning';

/**
 * Container
 */
const Container = styled.div`
  width: 100%;
  background: #383838;
`;

const TwinColumnedDesktop = styled.div`
  max-width: 50em;
  padding: 4em 1em;
  margin: 0 auto;
  > *:not(:last-child) {
    margin-bottom: 5em;
  }

  @media (min-width: 768px) {
    display: flex;
    > * {
      flex: 1;
    }
    > *:not(:last-child) {
      margin-right: 2em;
    }
  }
`;

/**
 * Landing page
 */
class LandingPage extends PureComponent {
  state = {
    confirm: false,
    modalOpen: false,
    shareUrl: ''
  };

  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  componentDidMount() {
    this.setState({
      shareUrl: window.location.href
    });
  }

  handleAnnouncementClick = () => {
    this.setState({
      confirm: false,
      modalOpen: true
    });
  };

  handleAnnouncementClose = () => this.setState({ modalOpen: false });

  handleBookClick = () => {
    this.setState({
      confirm: true,
      modalOpen: true
    });
  };

  render() {
    const { gameId, data } = this.props;
    return (
      <Container>
        <Translate>
          {({ translate }) => (
            <SocialButtons
              shareTitle={translate(`landingPage.games.${gameId}.title`)}
              shareUrl={this.state.shareUrl}
            />
          )}
        </Translate>
        <Announcement />
        <KeyVisual data={data} gameId={gameId} />
        <Mission gameId={gameId} />
        <Trailer />
        <Instructions />
        <Characters gameId={gameId} />
        <Information gameId={gameId} />
        <Devices gameId={gameId} />
        {gameId === '2' && <Trial />}
        <TwinColumnedDesktop>
          <News />
          <Faq gameId={gameId} />
        </TwinColumnedDesktop>
        <Warning />
        <Footer gameId={gameId} />
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global }, { location }) => ({
  gameId: global.gameId,
  section: new URLSearchParams(location.search).get('section')
});

export default compose(
  withLocalize,
  connect(mapStateToProps, null)
)(LandingPage);
